var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_5622)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5991 18.0387V6.59086H0.79446V18.0387H4.5991V18.0387ZM2.69718 5.02841C4.02352 5.02841 4.84972 4.14861 4.84972 3.05007C4.82464 1.92712 4.02352 1.07215 2.72205 1.07215C1.42037 1.07219 0.569542 1.92715 0.569542 3.05011C0.569542 4.14865 1.39529 5.02845 2.67213 5.02845L2.69718 5.02841ZM6.70482 18.0387C6.70482 18.0387 6.75473 7.66497 6.70482 6.59089H10.51V8.25108H10.4848C10.9851 7.46986 11.8865 6.32207 13.939 6.32207C16.4429 6.32207 18.3198 7.95825 18.3198 11.4746V18.0388H14.5152V11.9145C14.5152 10.3756 13.9647 9.32554 12.5874 9.32554C11.5365 9.32554 10.9102 10.0335 10.6352 10.7178C10.5345 10.9613 10.51 11.3035 10.51 11.6456V18.0387H6.70482Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_5622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.785,
    height: 17.785,
    fill: "white",
    transform: "translate(0.552177 0.66288)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.892830e98a7c501a775fb30ff4e35045.svg";
export { ForwardRef as ReactComponent };